import { useThemeUI } from "theme-ui"

const useTheme = () => {
  const context = useThemeUI()

  return context
}

export default useTheme
